import { render } from "./InvestmentsValueVolume.vue?vue&type=template&id=b753602e&scoped=true"
import script from "./InvestmentsValueVolume.vue?vue&type=script&lang=js"
export * from "./InvestmentsValueVolume.vue?vue&type=script&lang=js"

import "./InvestmentsValueVolume.vue?vue&type=style&index=0&id=b753602e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b753602e"]])

export default __exports__